import { render } from "./FormularioMaterial.vue?vue&type=template&id=3d035bfa&scoped=true"
import script from "./FormularioMaterial.vue?vue&type=script&lang=js"
export * from "./FormularioMaterial.vue?vue&type=script&lang=js"

import "./FormularioMaterial.vue?vue&type=style&index=0&id=3d035bfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d035bfa"]])

export default __exports__